'use strict';
'use es6';

// Similar to _.result, but with support for the single-arg case, e.g.
// `result(foo)` gives you `typeof foo === 'function' ? foo() : foo`.

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lazyEval;
function lazyEval(object, property) {
  var subject = property ? object[property] : object;
  return typeof subject === 'function' ? subject() : subject;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/utils/lazyEval.js
// module id = 299
// module chunks = 2 3